import { render, staticRenderFns } from "./Team4.vue?vue&type=template&id=3e843de8"
import script from "./Team4.vue?vue&type=script&lang=js"
export * from "./Team4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports